import { TimePicker } from 'antd'
import styled from '@emotion/styled'

export const StyledTimePicker = styled(TimePicker)`
  width: 100%;
`
